import React from 'react';

import { CartActions, ECartActions, ICartPageUpdateCompleteStateAction } from '../model';

export const updateCompleteState = (dispatch: React.Dispatch<CartActions>, data: ICartPageUpdateCompleteStateAction) =>
  dispatch({ actionType: ECartActions.UPDATE_COMPLETE_STATE, payload: data });
